import { TransmissionStatus } from '@alberta/konexi-shared';
import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { getSelectionItems } from 'src/app/business/selectionitem-factory';
import { InfoBoxType } from 'src/app/shared/components/common/info-box/info-box.component';
import { SelectionItem } from 'src/app/shared/models/selectionItem';

export enum ManualMedicalOrderRequestStatus {
  ToClarify = 'toClarify',
  Canceled = 'canceled',
  Faulty = 'faulty',
  CopyReceived = 'copyReceived',
  OriginalReceived = 'originalReceived',
}

@Component({
  selector: 'itl-service-order-medicalOrderRequest-status',
  templateUrl: './service-order-medicalOrderRequest-status.component.html',
})
export class ServiceOrderMedicalOrderRequestStatusComponent implements OnInit {
  @Input() public medicalOrderRequestStatus: TransmissionStatus;
  public medicalOrderRequestStatusTypes: SelectionItem[];
  public medicalOrderRequestStatusType: AbstractControl;
  public form: UntypedFormGroup;
  public warningType = InfoBoxType.Warning;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    private _translateService: TranslateService,
    private _modalController: ModalController
  ) {}

  public ngOnInit() {
    this.initializeForm();
    this.medicalOrderRequestStatusTypes = getSelectionItems(
      ManualMedicalOrderRequestStatus,
      'serviceOrder.medicalOrderRequestStatusType.',
      this._translateService
    );
  }

  private initializeForm() {
    this.form = this._formBuilder.group({
      medicalOrderRequestStatus: [this.medicalOrderRequestStatus],
    });
    this.medicalOrderRequestStatusType = this.form.controls['medicalOrderRequestStatus'];
  }

  public async save() {
    await this._modalController.dismiss(this.medicalOrderRequestStatus).catch(error => console.log(error));
  }
  public async cancel() {
    await this._modalController.dismiss().catch(error => console.log(error));
  }
}
